import { useStorageClipboard } from "./use_storage_clipboard";

const LESSON_COMPONENT_CLIPBOARD_STORAGE_KEY = "lessonComponentClipboard";
const LESSON_COMPONENT_CLIPBOARD_TTL_MS = 60 * 60 * 1000; // 1 hour
const LESSON_COMPONENT_CLIPBOARD_CHECK_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

export const useLessonComponentClipboard = () => {
	return useStorageClipboard({
		storageKey: LESSON_COMPONENT_CLIPBOARD_STORAGE_KEY,
		ttlMs: LESSON_COMPONENT_CLIPBOARD_TTL_MS,
		checkIntervalMs: LESSON_COMPONENT_CLIPBOARD_CHECK_INTERVAL_MS,
		parseErrorMessage: "Cannot parse lesson component clipboard:",
		syncErrorMessage: "Cannot sync lesson component clipboard:",
	});
};
